import React, { Fragment } from "react";
import Container from "../../../../components/Container";
import { refreshPage } from "../../../../helpers/common"

const TicketExpired = ({ type, eventName, goBack, eventTemplate }) => {
  return (
    <Fragment>
      <div className="error_page">
        <div className="overlay d-flex align-items-center">
          <div className="container">
            <h2 className="text-center mb-5" style={{ fontWeight: "600", color: `${eventTemplate === 1 ? "#000" : eventTemplate === 3 ? "#000" : "#fff"}` }}>{eventName}</h2>
            <div className="row mx-3 white-container py-5 px-4 px-md-0">
              {/* <div className=" mt-4 d-flex justify-content-center text-center">
                  <span className="error_message"> 
                    {" "}
                    {eventName}
                  </span>
                </div> */}
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 error_section error_section-image mb-3 mb-md-0">
                <img src="/img/ticket-expiry-icon.svg" alt="error" className="image-ticket-expiry w-75" />
              </div>
              <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 error_section">
                {type == 1 ? <div className="error_placehlder mb-3">
                  <span className="error_message">
                    {" "}
                    Oops! Ticket Expired!
                  </span>
                  <img
                    src="/img/yellowbeansplat.svg"
                    className="yellowbeansplat"
                    alt="pattern"
                  />
                </div> : type == 3 ? (
                  <div className="error_placehlder mb-3">
                    <span className="error_message">
                      {" "}
                      Oops! Ticket Coming Soon!
                    </span>
                    <img
                      src="/img/yellowbeansplat.svg"
                      className="yellowbeansplat"
                      alt="pattern"
                    />
                  </div>
                ) : null}
                {type == 1 ? <span className="error_dec mb-3">
                  {" "}
                  The ticket you're attempting to access has expired. <br></br>
                  Kindly contact the event organizer.
                </span> : type == 2 ?
                  <span className="error_dec mb-3">
                    {" "}
                    The link you are trying to access has expired because it was successfully used to make a payment.
                  </span> : (<span className="error_dec mb-3">
                    {" "}
                    The registration for the ticket you're attempting to access has not yet started.
                  </span>)}
                <span
                  className="error_referesh_page"
                  onClick={() => goBack()}
                >
                  Go back
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .error_page {
          background: ${eventTemplate === 1 ? "#fde6c4" : eventTemplate === 3 ? "#f6f6fc" : "#572148"} url("/img/404.svg");
          font-family: ${eventTemplate === 3 ? "Manrope" : "Prompt"};
          min-height: 100vh;
        }
        .overlay {
          position: relative;
          background: ${eventTemplate === 1 ? "rgba(255, 219, 166, 0.4)" : eventTemplate === 3 ? "rgba(0, 0, 0, 0)" : "rgba(87, 33, 72, 0.9)"};
          min-height: 100vh;
        }
        .image-ticket-expiry {
          max-width: 368px
        }

        .white-container{
          background: ${eventTemplate === 1 ? "#fff" : eventTemplate === 3 ? "white" : "#794d6d"};
          border-radius: 50px;
          min-height: 65vh
        }

        .error_section {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .error_section-image {
          align-items: center;
        }
        .error_placehlder {
          position: relative;
        }

        .error_message {
          display: block;
          font-weight: bold;
          font-size: 2rem;
          line-height: 2.5rem;
          color:  ${eventTemplate === 1 ? "#000" : eventTemplate === 3 ? "#000" : "#fff"};
        }

        .error_dec {
          display: block;
          font-weight: normal;
          font-size: 1.5rem;
          line-height: 2rem;
          color:  ${eventTemplate === 1 ? "#000" : eventTemplate === 3 ? "#000" : "#fff"};
        }

        .error_referesh_page {
          display: block;
          font-weight: bold;
          font-size: 1.5rem;
          line-height: 2rem;
          text-decoration-line: underline;
          color:  ${eventTemplate === 1 ? "#000" : eventTemplate === 3 ? "#000" : "#fff"};
          cursor: pointer;
        }

        .yellowbeansplat {
          position: absolute;
          height: 50px;
          top: 19px;
          left: -36px;
          opacity: 0.6;
        }

        @media (max-width: 991px) {
          .error_dec,
          .error_referesh_page {
            font-size: 1rem;
            line-height: 1.5rem;
          }
          .error_message {
            font-size: 1.5rem;
            line-height: 1.9rem;
          }
          .white-container {
            min-height: 50vh;
          }
        }
      `}</style>
    </Fragment>
  );
};

export default TicketExpired;
